export const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const DAY_TO_FULL_NAME = {
  Sun: "Zondag",
  Mon: "Maandag",
  Tue: "Dinsdag",
  Wed: "Woensdag",
  Thu: "Donderdag",
  Fri: "Vrijdag",
  Sat: "Zaterdag",
};
